import { render, staticRenderFns } from "./FulfillmentTasks.vue?vue&type=template&id=2e396830"
import script from "./FulfillmentTasks.vue?vue&type=script&lang=js"
export * from "./FulfillmentTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports